<template>
  <div :class="pageClasses">
    <slot></slot>
    <!-- Slot for dynamic content -->
  </div>
</template>

<script setup>
import { computed } from 'vue';

// Props are directly destructured in <script setup>
const props = defineProps({
  padding: {
    type: Boolean,
    default: false,
  },
});

// Define computed properties using Vue 3 Composition API
const pageClasses = computed(() => {
  return {
    // 'custom-page': true,
    // 'custom-page--padded': props.padding,
  };
});
</script>

<style scoped>
.custom-page {
  display: flex;
  flex-direction: column;
  flex: 1;
  /* overflow-y: auto; */
  min-height: 100vh; /* Ensure it takes up the full height */
  min-height: 100svh;
  min-height: 100dvh;
}

.custom-page--padded {
  padding: 16px;
}
</style>
